export { NaverPayDisabledIcon, NaverPayIcon } from './naver-pay-icon'
